import {
  Flex,
  FormLabel,
  Heading,
  Image,
  Input,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { Link, generatePath } from "react-router-dom";
import Loading from "../../../components/Loading/Loading";
import LoginButton from "../../../components/LoginButton/LoginButton";
import { API, API2 } from "../../../shared/Api/Api";
import InfoUserMobile from "../InfoUser/Mobile/InfoUserMobile";
import "./InfoAdmin.scss";

const InfoAdmin = ({ info, tabletOrLess, llamada, setReload, reload }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [loading, setLoading] = useState();
  const [success, setSuccess] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("video", data.video);
    formData.append("shortDescription", data.shortDescription);
    formData.append("description", data.description);
    formData.append("photo", data.photo[0]);
    formData.append("madeBy", JSON.parse(localStorage.getItem("user"))._id);
    setLoading(true);

    API2.post("info/", formData)
      .then((res) => {
        setLoading(false);
        llamada();
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          onClose();
        }, 2000);
      })
      .catch((error) => {
        setLoading(false);
        onClose();
      });
  };

  const borrar = (noticiaId) => {
    API.delete("info/" + noticiaId).then(() => {
      setReload(!reload);
    });
  };

  return (
    <>
      {/* desktop */}
      {!tabletOrLess ? (
        <>
          {info ? (
            <Flex
              flexWrap="wrap"
              justify="center"
              flexDir="column"
              pt="60px"
              backgroundColor="#ff6e6c"
              w="100%"
              minH="87vh"
            >
              <Heading
                mt="50px"
                mb="50px"
                textAlign="center"
                fontWeight="bold"
                fontSize="50px"
              >
                <Fade cascade triggerOnce damping={0.05}>
                <FormattedMessage
                id="app.info.heading"
              />
                </Fade>
              </Heading>
              <Flex flexWrap="wrap" justify="center" align="center">
                <Fade triggerOnce cascade>
                  {info.map((noticia) => {
                    return (
                      <Flex
                        key={noticia._id}
                        backgroundImage={noticia.photo}
                        w="650px"
                        h="300px"
                        backgroundPosition="center"
                        backgroundSize="cover"
                        backgroundRepeat="no-repeat"
                        m="50px"
                        p="1.5px"
                        transform="rotate(-2deg)"
                        transition="transform, 0.5s"
                        boxShadow="2px 4px 15px 1px rgba(0,0,0,0.82)"
                        borderRadius="10px"
                        _hover={{
                          width: "670px",
                          height: "320px",
                          margin: "35px",
                          transform: "rotate(0deg)",
                          transition: "all, 0.3s",
                        }}
                      >
                        <Image
                          w="100px"
                          position="absolute"
                          right="0"
                          mt="-25px"
                          src="/assets/chincheta.png"
                          alt="chincheta"
                        />
                        <Flex
                          backgroundColor="#FFFFFF"
                          w="250px"
                          h="95%"
                          m="10px"
                          justify="center"
                          align="center"
                          flexDir="column"
                          borderRadius="10px"
                        >
                          <Flex>
                            {noticia.description && noticia.video && (
                              <Link
                                className="Link"
                                to={generatePath("/novedades/:id", {
                                  id: noticia._id,
                                })}
                              >
                                <Image
                                  src="/assets/detail.png"
                                  alt="detalle"
                                  h="30px"
                                  mr="20px"
                                  cursor="pointer"
                                  transition="all, 0.5s"
                                  zIndex="2"
                                  _hover={{
                                    transform: "scale(1.5",
                                    transition: "all, 0.5s",
                                  }}
                                />
                              </Link>
                            )}
                            <Image
                              src="/assets/papelera.png"
                              alt="eliminar"
                              h="30px"
                              cursor="pointer"
                              transition="all, 0.5s"
                              zIndex="2"
                              _hover={{
                                transform: "scale(1.5",
                                transition: "all, 0.5s",
                              }}
                              onClick={(e) => borrar(noticia._id)}
                            />
                          </Flex>
                          <Text
                            textAlign="center"
                            fontSize="large"
                            w="100%"
                            mb="25px"
                            p="15px"
                          >
                            {noticia.shortDescription}
                          </Text>
                          <Heading
                            textAlign="center"
                            w="100%"
                            m="5px"
                            fontSize="25px"
                          >
                            {noticia.title}
                          </Heading>
                        </Flex>
                      </Flex>
                    );
                  })}

                  <Flex
                    w="650px"
                    h="300px"
                    backgroundColor="rgba(245, 245, 245, 0.694)"
                    justify="center"
                    align="center"
                    m="50px"
                    transform="rotate(-2deg)"
                    transition="transform, 0.5s"
                    borderRadius="10px"
                    boxShadow="2px 4px 15px 1px rgba(0, 0, 0, 0.82)"
                    _hover={{
                      width: "670px",
                      height: "320px",
                      margin: "35px",
                      transform: "rotate(0deg)",
                      transition: "all, 0.3s",
                      cursor: "pointer",
                    }}
                    onClick={onOpen}
                  >
                    <Image
                      h="50%"
                      src="https://cdn-icons-png.flaticon.com/512/43/43869.png"
                      alt="añadir"
                    />
                  </Flex>
                </Fade>
                <Modal
                  motionPreset="slideInBottom"
                  isOpen={isOpen}
                  onClose={onClose}
                  isCentered
                >
                  <ModalOverlay />
                  <ModalContent
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDir="column"
                    w="100vw"
                    h="100vh"
                    backgroundColor="#FFFFFF"
                    border="3px solid black"
                  >
                    <Image
                      w="40px"
                      position="absolute"
                      right={!tabletOrLess && "0"}
                      top="0"
                      left={tabletOrLess && "0"}
                      mt={tabletOrLess ? "25px" : "25px"}
                      cursor="pointer"
                      mr={!tabletOrLess && "20px"}
                      ml={tabletOrLess && "20px"}
                      src="https://res.cloudinary.com/dhp2zuftj/image/upload/v1654865079/MontseProyect/remove_1_vwlrs4.png"
                      onClick={onClose}
                      alt="close"
                    />
                    <form
                      autoComplete="off"
                      className="formAdmin"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <Flex
                        w="70vw"
                        h="100px"
                        m="5px"
                        justify="center"
                        align="flex-start"
                        flexDir="column"
                      >
                        <FormLabel fontWeight="bold">Título*</FormLabel>
                        <Input
                          border="none"
                          backgroundColor="#FFFFFF"
                          mt="15px"
                          p="8px"
                          fontWeight="bold"
                          borderBottom="3px solid black"
                          textAlign="center"
                          minW="70vw"
                          _focus={{ outline: "none" }}
                          required
                          placeholder="Titulo"
                          {...register("title")}
                        />
                      </Flex>
                      <Flex
                        w="70vw"
                        h="100px"
                        m="5px"
                        justify="center"
                        align="flex-start"
                        flexDir="column"
                      >
                        <FormLabel fontWeight="bold">Vídeo</FormLabel>
                        <Input
                          border="none"
                          backgroundColor="#FFFFFF"
                          mt="15px"
                          p="8px"
                          fontWeight="bold"
                          borderBottom="3px solid black"
                          textAlign="center"
                          minW="70vw"
                          _focus={{ outline: "none" }}
                          placeholder="https://enlace-de-video-de-youtube"
                          {...register("video")}
                        />
                      </Flex>
                      <Flex
                        w="70vw"
                        h="100px"
                        m="5px"
                        justify="center"
                        align="flex-start"
                        flexDir="column"
                      >
                        <FormLabel fontWeight="bold">
                          Descripción corta*
                        </FormLabel>
                        <Input
                          m="5px"
                          border="2px solid black"
                          textAlign="center"
                          borderRadius="10px"
                          minW="70vw"
                          fontWeight="bold"
                          minH="50px"
                          required
                          placeholder="Aquí va la descripción corta de la publicación, tiene un límite de 150 Caracteres"
                          {...register("shortDescription")}
                        />
                      </Flex>
                      <Flex
                        w="70vw"
                        h="100px"
                        m="5px"
                        justify="center"
                        align="flex-start"
                        flexDir="column"
                      >
                        <FormLabel fontWeight="bold">
                          Descripción larga
                        </FormLabel>
                        <Input
                          m="5px"
                          border="2px solid black"
                          textAlign="center"
                          borderRadius="10px"
                          minW="70vw"
                          fontWeight="bold"
                          minH="50px"
                          placeholder="Aquí va una descripción completa de la publicación, no tiene límite de caracteres."
                          {...register("description")}
                        />
                      </Flex>
                      <Flex
                        justify="center"
                        align="center"
                        flexDir="column"
                        mt="20px"
                      >
                        <FormLabel fontWeight="bold">
                          Selecciona la imagen de la publicación*
                        </FormLabel>
                        <Input
                          mt="30px"
                          fontWeight="bold"
                          textAlign="center"
                          required
                          type="file"
                          autoComplete="off"
                          {...register("photo")}
                        />
                      </Flex>
                      <Flex mt="50px">
                        {loading ? (
                          <Loading mini />
                        ) : success ? (
                          <Text
                            p="10px"
                            display="flex"
                            justifyContent="flex-start"
                            alignItems="center"
                            fontWeight="bold"
                            h="50px"
                            w="17vw"
                            backgroundColor="#c6f6d5"
                          >
                            <Image
                              mr="20px"
                              w="30px"
                              src="/assets/comprobado.png"
                              alt="check"
                            />
                            Publicado correctamente
                          </Text>
                        ) : (
                          <LoginButton texto="Publicar" />
                        )}
                      </Flex>
                    </form>
                  </ModalContent>
                </Modal>
              </Flex>
            </Flex>
          ) : (
            <Loading />
          )}
        </>
      ) : (
        <>
          {/* movil */}
          {info ? <InfoUserMobile info={info} /> : <Loading />}
        </>
      )}
    </>
  );
};

export default InfoAdmin;
